export const SHARE_MARKETING_MD = `
Thank you for registering for the Collective Napa Valley Barrel
Auction, hosted by Collective Napa Valley on Sotheby’s platform. We
hope you are successful with your bids! By checking the appropriate
box(es) below, you hereby consent to Sotheby’s sharing your
registered name and associated lot details with Collective Napa
Valley (CNV) and as applicable, CNV sharing this information with
the winery on whose wine you bid so they may contact you via email,
phone or post (depending on the contact information you have shared
with them independently) solely for the purpose(s) you’ve selected
below. You understand that your details will be processed by CNV and
any relevant wineries in accordance with their respective privacy
policies.
`;
